import React from 'react';

export default function GoogleSlidesViewer({ onClose }) {
  return (
    <>
      <style>{`
        .slides-close-button {
          position: fixed;
          top: 20px;
          right: 20px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          border: 2px solid rgba(255, 255, 255, 0.4);
          color: white;
          font-size: 32px;
          font-weight: 300;
          line-height: 1;
          cursor: pointer;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
          z-index: 102;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .slides-close-button:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.1);
        }
      `}</style>

      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 101,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#000'
        }}
      >
        <button
          className="slides-close-button"
          onClick={onClose}
          aria-label="Close slides"
        >
          ×
        </button>

        <iframe
          src="https://docs.google.com/presentation/d/e/2PACX-1vSsnhVjS-A13C52BlISn0esIl0uXJanSzId35NrtImKShKzwFBc-R6Kko7ohZBz3F1Ctpr34CoP0_4B/embed?start=true&loop=true&delayms=30000"
          frameBorder="0"
          allowFullScreen={true}
          title="Small Business Advertising Presentation"
          style={{
            width: '100%',
            height: '100%',
            border: 'none'
          }}
        />
      </div>
    </>
  );
}
